<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="my-5">
        <img width="300" src="../assets/health-here-logo.svg"/>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="alert alert-danger col-5" role="alert" v-show="generalErrorMessage">
        <div>{{ generalErrorMessage }}</div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-3">
        <form class="form-horizontal">
          <div class="bi-form">
            <b-form-group class="mr-3" label="First name" :state="stateForField('firstName')" :invalid-feedback="errorForField('firstName')">
              <b-form-input @input="clearFieldError('firstName')" :state="stateForField('firstName')" v-model="payee.firstName"></b-form-input>
            </b-form-group>
            <b-form-group label="Last name" :state="stateForField('lastName')" :invalid-feedback="errorForField('lastName')">
              <b-form-input @input="clearFieldError('lastName')" :state="stateForField('lastName')" v-model="payee.lastName"></b-form-input>
            </b-form-group>
          </div>
          <b-form-group label="Email" :state="stateForField('email')" :invalid-feedback="errorForField('email')">
            <b-form-input @input="clearFieldError('email')" :state="stateForField('email')" v-model="payee.email"></b-form-input>
          </b-form-group>
          <b-form-group label="Password" :state="stateForField('password')">
            <b-form-input type="password" @input="clearFieldError('password')" :state="stateForField('password')" v-model="payee.password"></b-form-input>
            <b-form-invalid-feedback :state="stateForField('password')" v-html="errorForField('password')"></b-form-invalid-feedback>
          </b-form-group>
          <div v-if="hideBusinessNameField === false">
          <b-form-group label="Business name" :state="stateForField('businessName')" :invalid-feedback="errorForField('businessName')">
            <b-form-input @input="clearFieldError('businessName')" :state="stateForField('businessName')" v-model="payee.businessName"></b-form-input>
          </b-form-group>
            <div class="bi-form">
            <b-form-group class="mr-3" label="NPI" :state="stateForField('npi')" :invalid-feedback="errorForField('npi')">
              <b-form-input :formatter="removeLeadingZeros" @input="clearFieldError('npi')" :state="stateForField('npi')" v-model="payee.npi"></b-form-input>
            </b-form-group>
            <b-form-group label="Tax Id" :state="stateForField('taxId')" :invalid-feedback="errorForField('taxId')">
              <b-form-input :formatter="removeLeadingZeros" @input="clearFieldError('taxId')" :state="stateForField('taxId')" v-model="payee.taxId"></b-form-input>
            </b-form-group>
            </div>
            <b-form-group label="Street Address" :state="stateForField('street1')" :invalid-feedback="errorForField('street1')">
              <b-form-input @input="clearFieldError('street1')" :state="stateForField('street1')" v-model="payee.street1"></b-form-input>
            </b-form-group>
            <b-form-group label="Street Address Line 2" :state="stateForField('street2')" :invalid-feedback="errorForField('street2')">
              <b-form-input @input="clearFieldError('street2')" :state="stateForField('street2')" v-model="payee.street2"></b-form-input>
            </b-form-group>
            <div class="tri-form">
              <b-form-group class="mr-3" label="City" :state="stateForField('city')" :invalid-feedback="errorForField('city')">
                <b-form-input @input="clearFieldError('city')" :state="stateForField('city')" v-model="payee.city"></b-form-input>
              </b-form-group>
              <b-form-group class="mr-3" label="State" :state="stateForField('stateId')" :invalid-feedback="errorForField('stateId')">
                <b-form-select @input="clearFieldError('stateId')" :state="stateForField('stateId')" v-model="payee.stateId" :options="stateOptions" :value-field="'stateId'" :text-field="'name'"></b-form-select>
              </b-form-group>
              <b-form-group label="Zip" :state="stateForField('zip')" :invalid-feedback="errorForField('zip')">
                <b-form-input @input="clearFieldError('zip')" :state="stateForField('zip')" v-model="payee.zip"></b-form-input>
              </b-form-group>
            </div>
          </div>
          <b-form-group :state="stateForField('termsOfService')" :invalid-feedback="errorForField('termsOfService')">
            <b-checkbox @input="clearFieldError('termsOfService')" :state="stateForField('termsOfService')" v-model="payee.termsOfService">
              I agree to the <b>Health Here</b> <a target="_blank" href="https://www.healthhere.com/terms-of-service">Terms Of Service</a>, <a target="_blank" href="https://www.healthhere.com/privacy-policy">Privacy Policy</a>
              and <b>Dwolla's</b> <a target="_blank" href="https://www.dwolla.com/legal/tos/">Terms of Service</a> and <a target="_blank" href="https://www.dwolla.com/legal/privacy/">Privacy Policy</a>.
            </b-checkbox>
          </b-form-group>
          <b-form-group :state="stateForField('paymentAgreement')" :invalid-feedback="errorForField('paymentAgreement')">
            <b-checkbox @input="clearFieldError('paymentAgreement')" :state="stateForField('paymentAgreement')" v-model="payee.paymentAgreement">
              I acknowledge and accept the <b>Health Here</b> <a target="_blank" href="https://www.healthhere.com/episodic-payment-program-agreement">Episodic Payment Program Agreement.</a>
            </b-checkbox>
          </b-form-group>
          <div class="form-group">
              <button type="submit" @click.prevent="submit()" class="btn btn-outline-orange">Agree and Create Account
                <font-awesome-icon size="lg" class="mr-2" v-show="isSaving" icon="spinner" pulse/>
              </button>
            </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '../services/api'
  import ErrorsMixin from '@/mixins/ErrorsMixin'

  export default {
    name: 'PayeeSignup',

    mixins: [ErrorsMixin],

    props: {
      email: {
        type: String,
        required: false
      },
      hideBusinessNameField: {
        type: Boolean,
        required: false
      }
    },

    data () {
      return {
        payee: {
          firstName: '',
          lastName: '',
          businessName: '',
          street1: '',
          street2: '',
          city: '',
          stateId: null,
          email: '',
          password: '',
          termsOfService: false,
          paymentAgreement: false
        },
        stateOptions: [
          { stateId: 1, short: 'AL', name: 'Alabama' },
          { stateId: 2, short: 'AK', name: 'Alaska' },
          { stateId: 3, short: 'AZ', name: 'Arizona' },
          { stateId: 4, short: 'AR', name: 'Arkansas' },
          { stateId: 5, short: 'CA', name: 'California' },
          { stateId: 6, short: 'CO', name: 'Colorado' },
          { stateId: 7, short: 'CT', name: 'Connecticut' },
          { stateId: 8, short: 'DE', name: 'Delaware' },
          { stateId: 9, short: 'DC', name: 'District Of Columbia' },
          { stateId: 10, short: 'FL', name: 'Florida' },
          { stateId: 11, short: 'GA', name: 'Georgia' },
          { stateId: 12, short: 'HI', name: 'Hawaii' },
          { stateId: 13, short: 'ID', name: 'Idaho' },
          { stateId: 14, short: 'IL', name: 'Illinois' },
          { stateId: 15, short: 'IN', name: 'Indiana' },
          { stateId: 16, short: 'IA', name: 'Iowa' },
          { stateId: 17, short: 'KS', name: 'Kansas' },
          { stateId: 18, short: 'KY', name: 'Kentucky' },
          { stateId: 19, short: 'LA', name: 'Louisiana' },
          { stateId: 20, short: 'ME', name: 'Maine' },
          { stateId: 21, short: 'MD', name: 'Maryland' },
          { stateId: 22, short: 'MA', name: 'Massachusetts' },
          { stateId: 23, short: 'MI', name: 'Michigan' },
          { stateId: 24, short: 'MN', name: 'Minnesota' },
          { stateId: 25, short: 'MS', name: 'Mississippi' },
          { stateId: 26, short: 'MO', name: 'Missouri' },
          { stateId: 27, short: 'MT', name: 'Montana' },
          { stateId: 28, short: 'NE', name: 'Nebraska' },
          { stateId: 29, short: 'NV', name: 'Nevada' },
          { stateId: 30, short: 'NH', name: 'New Hampshire' },
          { stateId: 31, short: 'NJ', name: 'New Jersey' },
          { stateId: 32, short: 'NM', name: 'New Mexico' },
          { stateId: 33, short: 'NY', name: 'New York' },
          { stateId: 34, short: 'NC', name: 'North Carolina' },
          { stateId: 35, short: 'ND', name: 'North Dakota' },
          { stateId: 36, short: 'OH', name: 'Ohio' },
          { stateId: 37, short: 'OK', name: 'Oklahoma' },
          { stateId: 38, short: 'OR', name: 'Oregon' },
          { stateId: 39, short: 'PA', name: 'Pennsylvania' },
          { stateId: 40, short: 'RI', name: 'Rhode Island' },
          { stateId: 41, short: 'SC', name: 'South Carolina' },
          { stateId: 42, short: 'SD', name: 'South Dakota' },
          { stateId: 43, short: 'TN', name: 'Tennessee' },
          { stateId: 44, short: 'TX', name: 'Texas' },
          { stateId: 45, short: 'UT', name: 'Utah' },
          { stateId: 46, short: 'VT', name: 'Vermont' },
          { stateId: 47, short: 'VA', name: 'Virginia' },
          { stateId: 48, short: 'WA', name: 'Washington' },
          { stateId: 49, short: 'WV', name: 'West Virginia' },
          { stateId: 50, short: 'WI', name: 'Wisconsin' },
          { stateId: 51, short: 'WY', name: 'Wyoming' },
          { stateId: 52, short: 'PR', name: 'Puerto Rico' },
          { stateId: 53, short: 'VI', name: 'Virgin Islands' }
        ],
        isSaving: false,
        nextPath: '/payee-dashboard'
      }
    },
    watch: {
      email: {
        immediate: true,
        handler (newValue, oldValue) {
          if (newValue !== oldValue) {
            this.payee.email = newValue
          }
        }
      }
    },
    methods: {
      removeLeadingZeros (str) {
        return str.replace(/^0+(?=\d)/, '')
      },
      validate () {
        this.clearAllErrors()

        if (!this.payee.firstName) {
          this.addErrorForField('firstName', 'You must provide your first name')
        }

        if (!this.payee.lastName) {
          this.addErrorForField('lastName', 'You must provide your last name')
        }

        if (!this.payee.email) {
          this.addErrorForField('email', 'You must provide your email')
        }

        if (!this.payee.termsOfService) {
          this.addErrorForField('termsOfService', 'You must agree to the terms of service')
        }

        if (!this.payee.paymentAgreement) {
          this.addErrorForField('paymentAgreement', 'You must agree to the Episodic Payment Program Agreement.')
        }

        return !this.hasErrors()
      },
      submit () {
        if (!this.validate()) {
          return
        }

        if (this.isSaving) {
          return
        }
        const taxId = this.payee.taxId
        if (this.payee.taxId) {
          this.payee.taxId = taxId.replace(/[^\d]/g, '')
        }

        const npi = this.payee.npi
        if (this.payee.npi) {
          this.payee.npi = npi.replace(/[^\d]/g, '')
        }
        this.isSaving = true
        api.post('/Dashboard/PayeeSignup', this.payee).then(response => {
          const data = response.data

          if (!data.organizationId) {
            this.errors = ['This user is not configured for an organization']
          } else {
            const userRoles = data.users[0].user.roles.filter(role => role === 'OrganizationPayee')

            if (userRoles && userRoles.length > 0) {
              this.$router.push('/login')
            } else {
              this.errors = ['This user does not have the appropriate roles to access the dashboard']
            }
          }
          this.isSaving = false
        }).catch(error => {
          this.isSaving = false
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
            this.$log.error('Error attempting to add payee: ' + error.message, error)
          }
        })
      }
    }
  }
</script>

<style scoped>
.bi-form {
  display: flex;
}
.tri-form {
  display: flex;
}
</style>
